module.exports = __webpack_public_path__ + "static/media/THE CALF 2.8115bd2e.jpg";